<script>
export default {
  props: {
    /**
     * When used in headers the value can come in as a string or object (e.g. $.metadata.fields[6] returns an array of csv of key=value pairs)
     * @model
     */
    value: {
      type:    [String, Object, Array],
      default: '',
    },
  },

  data() {
    return { expanded: false };
  },
  computed: {
    parsed() {
      let value = this.value;

      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch {
          return value ? [value] : [];
        }
      }
      if (!value || typeof value !== 'object') {
        return [];
      }

      if (Array.isArray(value)) {
        return value.map((entry) => typeof entry === 'string' ? entry : JSON.stringify(entry));
      }

      return Object.keys(value).map((key) => `${ key }=${ value[key] }`);
    },
    visible() {
      return this.expanded ? this.parsed : this.parsed.slice(0, 3);
    }
  },
  watch: {
    value() {
      this.expanded = false;
    }
  }

};
</script>

<template>
  <div class="formatter-key-value-container">
    <span
      v-if="!parsed.length"
      class="text-muted"
    >—</span>
    <span
      v-for="(kv, index) in visible"
      :key="index"
      class="formatter-key-value-item"
      :title="kv"
    >{{ kv }}</span>
    <button
      v-if="parsed.length > 3"
      type="button"
      class="btn role-link selector-toggle"
      :aria-expanded="expanded"
      @click="expanded = !expanded"
    >
      {{ t(expanded ? 'generic.showLess' : 'generic.showMore') }}<span v-if="!expanded"> ({{ parsed.length - 3 }})</span>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.formatter-key-value-container { display: flex; flex-wrap: wrap; align-items: flex-start; gap: 5px; min-width: 0; }
.formatter-key-value-item { max-width: 100%; padding: 3px 6px; border: 1px solid var(--border); border-radius: 5px; background: var(--simple-box-bg, var(--body-bg)); color: var(--muted); font-size: 12px; line-height: 1.4; overflow-wrap: anywhere; }
.selector-toggle { padding: 2px 0; min-height: 24px; font-size: 12px; }
</style>
